var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:_vm.alertClass},[(_vm.title)?_c('p',{staticClass:"h4 alert-heading mb-1"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }